/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MainPatientAvatar.vue?vue&type=template&id=b7bd429c&scoped=true"
import script from "./MainPatientAvatar.vue?vue&type=script&lang=js"
export * from "./MainPatientAvatar.vue?vue&type=script&lang=js"
import style0 from "./MainPatientAvatar.vue?vue&type=style&index=0&id=b7bd429c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bd429c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7bd429c')) {
      api.createRecord('b7bd429c', component.options)
    } else {
      api.reload('b7bd429c', component.options)
    }
    module.hot.accept("./MainPatientAvatar.vue?vue&type=template&id=b7bd429c&scoped=true", function () {
      api.rerender('b7bd429c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/partials/MainPatientAvatar.vue"
export default component.exports